'use client';

import React from 'react';
import styled, { css } from 'styled-components';

import Toggle, { ToggleProps } from './Toggle';
import useTranslation from '../translation/useTranslation';
import { useNavbar, useToggles } from './state';

interface LogoutProps extends Partial<ToggleProps> {
  onConfirm?: () => void;
}

function Logout({
  id = 'logout',
  icon = <i aria-hidden>logout</i>,
  title = '',
  trackid = 'menu-1_expand|Logg ut',
  ...props
}: Partial<LogoutProps>) {
  const { t } = useTranslation();
  const { setOpenId } = useToggles();
  const { navbarProps } = useNavbar();

  const onConfirm = props.onConfirm || navbarProps.logout;

  return (
    <Toggle
      id={id}
      trackid={trackid}
      title={title || t('logout.text')}
      icon={icon}
    >
      <LogoutBase>
        <p>{t('logout.heading')}</p>
        <Button
          onClick={() => {
            onConfirm?.();
          }}
        >
          {t('logout.confirm')}
        </Button>
        <Button variant="text" onClick={() => setOpenId('logout')}>
          {t('logout.cancel')}
        </Button>
      </LogoutBase>
    </Toggle>
  );
}

export const LogoutBase = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  align-items: center;

  & > p {
    color: inherit;
  }
`;

export type ButtonProps = {
  variant?: 'contained' | 'text';
};

export const Button = styled.button.attrs({
  type: 'button',
})<ButtonProps>`
  font-size: 16px;
  line-height: 24px;

  padding: 8px 24px;
  color: var(--navbar-toggle-accent-color, #282828);
  background: var(--navbar-toggle-accent-background, #fff);

  border: none;

  border-radius: 20px;

  cursor: pointer;

  &:hover {
    background: var(--navbar-toggle-accent-background-hover, #ffdfdf);
  }

  &:focus-visible {
    outline-offset: 4px;
    outline: 2px solid var(--navbar-toggle-color, #fff);
  }

  ${({ variant }) =>
    variant === 'text' &&
    css`
      color: #fff;
      background: var(--navbar-toggle-background, #700);

      padding: 7px 23px;
      border: 1px solid var(--navbar-toggle-accent-background-hover, #ffdfdf);

      &:hover {
        padding: 6px 22px;

        border: 2px solid var(--navbar-toggle-accent-background-hover, #ffdfdf);
        background: var(--navbar-toggle-background, #700);
      }
    `}
`;

export default Logout;
